export enum DataTypesEnum {
    ARRAY = "ARRAY",
    MAP = "MAP"
}


// WEBPACK FOOTER //
// ./app/components/bo-core/enums/dataTypesEnum.ts